function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M304 261L130 435c-15 15-15 39 0 54 15 16 39 15 54 0l198-198c9-8 12-19 11-30 1-11-2-22-11-30L184 32c-15-14-39-15-54 0s-15 40 0 55z"
})));